export default class CheckeDevice {
  constructor(el){
    this.element = $(el);
    this.win = $(window);
    this.timer = 200;
    this.resize();
    this.checkDevice();
  }

  checkDevice(){
    this.device = this.element.is(':visible') ? 'sp' : 'pc';
  }

  resize(){
    let t = false;
    this.winWidth = this.win.width();
    this.win.on('resize', (e) => {
      let $this = $(e.currentTarget);
      let currentWidth = $this.width();
      if(this.winWidth !== currentWidth){
        if(t !== false){
          clearTimeout(t);
        }
        t = setTimeout(() => {
          this.checkDevice();
        }, this.timer);
      }
    });
  }
}




// WEBPACK FOOTER //
// ./js/_modules/_checkDevice.js